import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateNotification: [],
  loading: false,
  error: null,
};

const updateNotificationSlice = createSlice({
  name: "updateNotification",
  initialState,
  reducers: {
    fetchUpdateNotificationRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchUpdateNotificationSuccess: (state, action) => {
      state.loading = false;
      state.updateNotification = action.payload;
    },

    fetchUpdateNotificationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUpdateNotificationRequest,
  fetchUpdateNotificationSuccess,
  fetchUpdateNotificationFailure,
} = updateNotificationSlice.actions;

export default updateNotificationSlice.reducer;